// src/redux/homePostSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../pages/Constants';
// Define the async thunk for fetching data
export const fetchhomePost = createAsyncThunk(
  'homePost/fetchData',
  async () => {
    const lang =  localStorage.getItem('current_lang') || 'en'; 
    const response = await axios.get(`${base_url}/api/home-posts`,{
      headers:{
        language:lang
      }
    });
    return response.data; 
  }
);
 
// Create a slice
const homePostSlice = createSlice({
  name: 'homePost',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchhomePost.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhomePost.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchhomePost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export the reducer
export default homePostSlice.reducer;
